import React, { ReactElement, memo } from "react";
import { Portal, Overlay, OverflowHidden } from "@swiggy-private/core-ui";
import styles from "./TransactionProgressLoader.scss";

import CircleLoader from "@payment-ui/widgets/circle-loader";

function TransactionProgressLoader(): ReactElement {
    return (
        <Portal>
            <OverflowHidden>
                <>
                    <Overlay visible={true} className={styles.overlay} />
                    <div className={styles.circleContainer}>
                        <CircleLoader size="large" />
                    </div>
                </>
            </OverflowHidden>
        </Portal>
    );
}

export default memo(TransactionProgressLoader);
